export default __webpack_public_path__ + "static/josh-db93d5436552474fb62ac747e767661e.jpg";